import { type ConfigTypes } from "@tokenterminal/tt-analytics-api-types/dist/api/configs"
import { apiPOST } from "data/api/post"
import { createStableObject } from "utils/stableObjectKeys"

export function postStateConfig<T>(args: T, type: ConfigTypes) {
  return apiPOST(`/v3/internal/configs`, {
    type,
    version: 2,
    config: createStableObject(args),
  })
}
